import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const FAQ_ITEMS: { q: string; a: React.ReactNode }[] = [
  {
    q: 'お支払い方法を教えてください',
    a: '銀行振込・クレジットカード決済がご利用いただけます。銀行振込の場合は、ご注文確定後に振込先をご案内し、入金確認後7日以内に発送いたします。振込手数料はお客様のご負担となりますので、あらかじめご了承ください。クレジットカード決済の場合は、ご注文完了後すぐに発送準備を開始します。',
  },
  {
    q: '送料はいくらですか?',
    a: (
      <>
        ご注文内容によって送料が異なります。詳しくは
        <Link to="/shipping" className="text-primary-500 underline">配送についてのページ</Link>
        をご覧ください。
      </>
    ),
  },
  {
    q: '在庫がない商品は購入できますか?',
    a: '在庫が0の商品には「Sold Out」と表示され、ご購入いただけません。再入荷までしばらくお待ちください。',
  },
  {
    q: '不良品・誤発送があった場合はどうすればいいですか?',
    a: '不良品または当店の誤発送の場合のみ、交換にて対応いたします。お問い合わせよりご連絡ください。お客様都合による返品・交換は承っておりません。',
  },
];

export default function FaqPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16">
        <div className="bg-secondary-50 py-16 px-6 text-center">
          <p className="text-xs tracking-[0.3em] text-primary-500 mb-3 uppercase"
            style={{ fontFamily: "var(--font-heading)" }}>
            FAQ
          </p>
          <h1 className="text-4xl md:text-6xl font-light text-foreground-950"
            style={{ fontFamily: "var(--font-heading)" }}>
            よくある質問
          </h1>
        </div>

        <div className="max-w-3xl mx-auto px-6 py-14 space-y-6">
          {FAQ_ITEMS.map(item => (
            <div key={item.q} className="border border-background-200 rounded-xl p-6">
              <p className="text-sm text-foreground-900 mb-3 flex gap-2" style={{ fontFamily: "var(--font-heading)" }}>
                <span className="text-primary-500">Q</span>
                {item.q}
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed flex gap-2" style={{ fontFamily: "var(--font-body)" }}>
                <span className="text-secondary-600" style={{ fontFamily: "var(--font-heading)" }}>A</span>
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
